import React from "react";
import "./Footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>© Conference Organisers</p>
      </div>
      <div className="design">
        <p>Design by ADVANCE CRT</p>
      </div>
    </div>
  );
};
